module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "page-breadcrumb"
  }, _vm._l((_vm.crumbs), function(crumb, index) {
    return _c('li', [(crumb.link) ? _c('router-link', {
      attrs: {
        "to": crumb.link
      }
    }, [_vm._v(_vm._s(crumb.name))]) : _vm._e(), _vm._v(" "), (!crumb.link) ? _c('span', [_vm._v(_vm._s(crumb.name))]) : _vm._e(), _vm._v(" "), (index != _vm.crumbs.length - 1) ? _c('i', {
      staticClass: "fa fa-circle"
    }) : _vm._e()], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-042893de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Breadcrumb.vue
// module id = 401
// module chunks = 1